var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2622_6353)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2622_6353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 41.8317L30.6979 38.2067H30.3958C27.5361 38.2067 25.1094 37.2098 23.1156 35.2161C21.1219 33.2223 20.125 30.7956 20.125 27.9359C20.125 25.0762 21.1219 22.6494 23.1156 20.6557C25.1094 18.6619 27.5361 17.665 30.3958 17.665C31.8257 17.665 33.1599 17.9319 34.3984 18.4656C35.637 18.9992 36.7245 19.7343 37.6609 20.6708C38.5974 21.6072 39.3325 22.6947 39.8661 23.9333C40.3998 25.1718 40.6667 26.506 40.6667 27.9359C40.6667 29.4463 40.42 30.8963 39.9266 32.2859C39.4332 33.6755 38.7585 34.9643 37.9026 36.1525C37.0467 37.3407 36.0297 38.4182 34.8516 39.3848C33.6734 40.3515 32.3896 41.1671 31 41.8317ZM30.3656 34.5515C30.708 34.5515 31 34.4307 31.2417 34.189C31.4833 33.9473 31.6042 33.6553 31.6042 33.313C31.6042 32.9706 31.4833 32.6786 31.2417 32.4369C31 32.1952 30.708 32.0744 30.3656 32.0744C30.0233 32.0744 29.7312 32.1952 29.4896 32.4369C29.2479 32.6786 29.1271 32.9706 29.1271 33.313C29.1271 33.6553 29.2479 33.9473 29.4896 34.189C29.7312 34.4307 30.0233 34.5515 30.3656 34.5515ZM29.4896 30.715H31.3021C31.3021 30.1109 31.3625 29.688 31.4833 29.4463C31.6042 29.2046 31.9868 28.7616 32.6312 28.1171C32.9937 27.7546 33.2958 27.3619 33.5375 26.939C33.7792 26.5161 33.9 26.063 33.9 25.5796C33.9 24.5525 33.5526 23.7822 32.8578 23.2687C32.163 22.7551 31.3424 22.4984 30.3958 22.4984C29.5097 22.4984 28.7646 22.7451 28.1604 23.2385C27.5562 23.7319 27.1333 24.331 26.8917 25.0359L28.5833 25.7005C28.684 25.3581 28.8753 25.0208 29.1573 24.6885C29.4392 24.3562 29.8521 24.19 30.3958 24.19C30.9396 24.19 31.3474 24.3411 31.6193 24.6432C31.8911 24.9452 32.0271 25.2775 32.0271 25.64C32.0271 25.9824 31.9264 26.2895 31.725 26.5614C31.5236 26.8333 31.2819 27.1102 31 27.3921C30.2951 27.9963 29.8672 28.4746 29.7161 28.827C29.5651 29.1794 29.4896 29.8088 29.4896 30.715Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2622_6353",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2622_6353"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2622_6353",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2622_6353",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupporticon);
export default __webpack_public_path__ + "static/media/support+icon.53af8466a547139a94fd056fe22a63ac.svg";
export { ForwardRef as ReactComponent };